<!-- 
Panel for displaying the timing configuration for a levy collection.
-->
<template>
  <div class="my-0">
    <our-loading-indicator v-if="state.loading"/>
    <template v-else>
      <our-data-container>
        <our-data-field label="Cut-off date for in-scope providers">
          {{ configuration.inScopeCutoffDate | compactDate }}
        </our-data-field>
        <our-data-field v-if="showLevyParametersAsAtDate" label="As at date for levy calculation parameters">
          {{ configuration.levyParametersAsAtDate | compactDate }}
        </our-data-field>
      </our-data-container>
      <p v-if="forSandbox" class="text-xs-center">
        (Timings are shown here for information only - they cannot be altered on sandboxes.)
      </p>
      <div class="text-xs-center py-2">
        <v-btn v-if="canEdit" @click="showEditDialog=true">
          <v-icon class="mr-2">edit</v-icon>
          Edit
        </v-btn>
      </div>
    </template>
    <levy-calculation-timing-configuration-dialog v-model="showEditDialog" :levy-collection-id="levyCollectionId" />
  </div>
</template>

<script>
import lookupMixins from "@/mixins/lookup.mixins";
import filterMixins from "@/mixins/filter.mixins";
import * as claim from "@/store/claim-types";
import * as action from "@/store/levy-collections/action-types";
import LevyCalculationTimingConfigurationDialog from "@/components/levy-collection-setup/LevyCalculationTimingConfigurationDialog.vue";

export default {
  components: { LevyCalculationTimingConfigurationDialog },
  mixins: [lookupMixins, filterMixins],
  props: {
    levyCollectionId: {
      type: Number,
      required: true
    },
    forSandbox: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showEditDialog: false
    };
  },
  computed: {
    state() {
      return this.$store.state.levyCollections.viewLevyCalculationTimingConfiguration;
    },
    loaded() {
      return this.state.loaded;
    },
    configuration() {
      return this.state.data;
    },
    canEdit() {
      const hasPermission = this.$store.getters.claims.includes(
        claim.LEVY_COLLECTION_CONFIGURE_LEVY_CALCULATION_TIMING
      );
      const isAllowableStatus = this.doesLookupHaveAttribute(
        this.configuration.status,
        "CanEditLevyCalculationTimingConfiguration",
        this.lookups.levyCollectionStatuses
      );
      return hasPermission && isAllowableStatus && !this.forSandbox;
    },
    showLevyParametersAsAtDate() {
      return this.state.data.levyCollectionType == "Vsl";
    }
  },
  watch: {
    levyCollectionId() {
      this.refresh();
    },
    loaded() {
      this.refresh();
    }
  },
  mounted() {
    this.refresh();
  },
  methods: {
    refresh() {
      const needsReloaded =
        (!this.state.loaded && !this.state.loading) || this.state.levyCollectionId != this.levyCollectionId;
      if (needsReloaded) {
        this.$store.dispatch(action.VIEW_LEVY_CALCULATION_TIMING_CONFIGURATION, this.levyCollectionId);
      }
    }
  }
};
</script>
